import Vue from 'vue'

if (typeof window !== 'undefined') {
  const carousel = () => import('vue-owl-carousel')
  Vue.component('carousel', carousel)
}
